interface InstanceType {
    disabled: boolean;
    label: string;
    offLabel?: string;
    value: string;
}

const instanceTypes: InstanceType[] = [
    { disabled: false, label: 'None', offLabel: 'Remote', value: '' },
    { disabled: false, label: 'Site', offLabel: 'Off site', value: 'site' },
    { disabled: false, label: 'Office', offLabel: 'Remote', value: 'office' },
    { disabled: false, label: 'Coworking Space', offLabel: 'Remote', value: 'coworking_space' },
    { disabled: false, label: 'University', offLabel: 'Remote', value: 'university' },
    { disabled: true, label: 'Venue', offLabel: 'Off venue', value: 'venue' },
    { disabled: true, label: 'Construction Site', offLabel: 'Off site', value: 'construction_site' },
    { disabled: true, label: 'Production Facility', offLabel: 'Off facility', value: 'production_facility' },
    { disabled: true, label: 'Shopping Mall', offLabel: 'Off mall', value: 'shopping_mall' },
    { disabled: true, label: 'Retail Chain', offLabel: 'Off site', value: 'retail_chain' },
    { disabled: true, label: 'Mining', offLabel: 'Off site', value: 'mining' },
    { disabled: true, label: 'Fulfillment Centre', offLabel: 'Remote', value: 'fulfillment_centre' },
    { disabled: true, label: 'Public Transport', offLabel: 'Off route', value: 'public_transport' },
    { disabled: true, label: 'Ferry', offLabel: 'Off vessel', value: 'ferry' },
    { disabled: true, label: 'Agricultural Facility', offLabel: 'Off facility', value: 'agricultural_facility' },
];

export default instanceTypes;
